import React from 'react'
import { Platform } from 'react-native'
import Svg, { Circle, Path } from 'react-native-svg'
import { useTheme } from '../../hooks/useTheme'

/** Explicit SVG strokes avoid platform emoji substitution and utility-fill gaps. */
export function MoreReactionsIcon() {
  const { theme } = useTheme()
  const ink = theme === 'dark' ? '#e6e1c4' : '#18170f'
  const accessibilityProps = Platform.OS === 'web' ? { 'aria-hidden': true as const } : { accessible: false }
  return <Svg width={26} height={22} viewBox="0 0 26 22" {...accessibilityProps} pointerEvents="none">
    <Circle cx={9} cy={11} r={8} fill="none" stroke={ink} strokeWidth={1.7} />
    <Circle cx={6.2} cy={8.5} r={1} fill={ink} />
    <Circle cx={11.8} cy={8.5} r={1} fill={ink} />
    <Path d="M5.5 12.5 Q9 17 12.5 12.5" fill="none" stroke={ink} strokeWidth={1.7} strokeLinecap="round" />
    <Path d="M18 11 H25 M21.5 7.5 V14.5" fill="none" stroke={ink} strokeWidth={1.7} strokeLinecap="round" />
  </Svg>
}
